import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(LanguageDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    // disabled in production
    debug: false,
    // can have multiple namespaces, in case you want to divide a huge
    // translation into smaller pieces and load them on demand
    ns: ['common', 'client', 'layouts', 'dashboard', 'forms', 'communities'],
    detection: {
      // order and from where user language should be detected
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      // cache user language on
      caches: ['localStorage', 'cookie'],
    },
    backend: {
      // translation file path
      loadPath: '/assets/i18n/{{ns}}/{{lng}}.json',
    },
    interpolation: {
      escapeValue: true, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
